import { useEffect } from 'react';
import { scopedKey, resolveFacilityScopeId } from './bookingUtils';

/** Persists booking-domain state to localStorage as backup. */
export function useBookingPersistence({ state, activeFacilityId }) {
  useEffect(() => {
    try {
      const facilityScopeId = resolveFacilityScopeId(activeFacilityId);
      const bookingsKey = scopedKey('topgame_bookings', facilityScopeId);
      const facilityKey = scopedKey('topgame_facility', facilityScopeId);
      const slotConfigKey = scopedKey('topgame_slotConfiguration', facilityScopeId);

      if (state.bookings && state.bookings.length > 0) {
        localStorage.setItem(bookingsKey, JSON.stringify(state.bookings));
      }

      if (state.facility && (state.facility.name || state.facility.services?.length > 0)) {
        localStorage.setItem(facilityKey, JSON.stringify(state.facility));
      }

      const hasServices = state.slotConfiguration?.services && state.slotConfiguration.services.length > 0;
      const hasDateRange =
        state.slotConfiguration?.dateRange &&
        (state.slotConfiguration.dateRange.startDate || state.slotConfiguration.dateRange.endDate);

      if (hasServices || hasDateRange) {
        const configToSave = {
          dateRange: state.slotConfiguration.dateRange
            ? {
                startDate:
                  state.slotConfiguration.dateRange.startDate instanceof Date
                    ? state.slotConfiguration.dateRange.startDate.toISOString()
                    : state.slotConfiguration.dateRange.startDate,
                endDate:
                  state.slotConfiguration.dateRange.endDate instanceof Date
                    ? state.slotConfiguration.dateRange.endDate.toISOString()
                    : state.slotConfiguration.dateRange.endDate,
              }
            : null,
          services: state.slotConfiguration.services || [],
        };
        localStorage.setItem(slotConfigKey, JSON.stringify(configToSave));
      }
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
  }, [state.bookings, state.facility, state.slotConfiguration, activeFacilityId]);
}
